import React from "react";
import PowerBILogo from "../../assets/img/powerbi_logo.svg";

/**
 * PowerBI Icon Component - uses the official PowerBI logo SVG.
 */
export const PowerBIIcon = ({ size = 20, ...props }) => {
  return (
    <img
      src={PowerBILogo}
      alt="PowerBI"
      width={size}
      height={size}
      style={{ objectFit: "contain", ...props.style }}
      {...props}
    />
  );
};

export default PowerBIIcon;
